import React, { useState, useEffect, useContext, useRef } from 'react';
import { TextField, Checkbox, FormControlLabel, LinearProgress } from '@material-ui/core'
import api from './Api';
import { BulkActionsContext } from './BulkActionsContext';
import _ from 'lodash';
import { useDebounce } from 'use-debounce';




export default function ProductSearch({resetFilter,onSearchTextChanged}) {
    const [searchText, setSearchText] = useState('');
    const [productList, setProductList] = useState([]);
    const [filteredProductList, setFilteredProductList] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState({});
    const { dispatch } = useContext(BulkActionsContext);
    const [ showProductLoader, setShowProductLoader] = useState(true);
    const [allSelected, setAllselected] = useState(false);
    let prevBookingFilterRef = useRef(resetFilter);
    useEffect(() => {
        async function getData() {
            const data = await api.getProducts()
            setProductList(data);
            setFilteredProductList(data);
        }
        getData()
        setShowProductLoader(true);
    }, [])

    useEffect(() => {
        
        setProductList([]);
        setFilteredProductList([]);
        setSelectedProducts([]);
        setAllselected(false);
        setSearchText('');
        async function getData() {
            const data = await api.getProducts()
            setProductList(data);
            setFilteredProductList(data);
        }
        if (!_.isEqual(prevBookingFilterRef.current, resetFilter)) {
            getData();
        }
        setSearchText('')
        setShowProductLoader(true);

    }, [resetFilter])

    const [debouncedSearchTerm] = useDebounce(searchText, 500);

    const searchTextChanged = (e) => {
        // setShowProductLoader(true);
        setSearchText(e.target.value);
        onSearchTextChanged(e.target.value)
    }

    const filterHash = useRef({})
    useEffect(() => {
        // First we filter all the potential products based on search text
        let newProductList = [];
        if (!debouncedSearchTerm) {
            newProductList = productList;
        } else {
            const stl = debouncedSearchTerm.toLocaleLowerCase();
            if (filterHash.current[debouncedSearchTerm]) {
                newProductList = filterHash.current[debouncedSearchTerm].filter((item) => { return item.name.toLowerCase().indexOf(stl) > -1; })
            } else {
                newProductList = productList.filter((item) => { return item.name.toLowerCase().indexOf(stl) > -1; })
            }
        }


        // Now we look at all selected products.
        // If select all is checked, just reset the list to whatever matches the search text
        // If select all is not checked, we try to keep selected products in the list
        // even if they don't match the search text
        if (Object.keys(selectedProducts).length > 0) {
            const selectedProductList = Object.keys(selectedProducts).reduce(
                (prev, k) => { 
                    if (selectedProducts[k].isSelected) { 
                        const isInFilteredList = newProductList.find(p => p.id === k);
                        if (isInFilteredList) {
                            return [...prev, selectedProducts[k]?.product]  
                        } else {
                            return prev
                        }
                        
                        
                        // if (allSelected && isInFilteredList) {
                        //     return [...prev, selectedProducts[k]?.product]  
                        // } else if (!allSelected && isInFilteredList) {
                        //     return [...prev, selectedProducts[k]?.product]  
                        // } else if (!allSelected && !isInFilteredList) {
                        //     newProductList = [selectedProducts[k]?.product, ...newProductList];
                        //     return [...prev, selectedProducts[k]?.product]  
                        // } else { return prev }
                    } else { 
                        return prev
                    }
                }, [] );
                dispatch({ type: 'setProductFilter', productList :  selectedProductList});
                // if (selectedProductList.length === newProductList.length) { 
                //     setAllselected(true)
                // } else {
                //     setAllselected(false)
                // }
        } else {
            dispatch({ type: 'setProductFilter', productList :  []})
            setAllselected(false)
        }

        if (debouncedSearchTerm) { filterHash.current[debouncedSearchTerm] = newProductList }

        setFilteredProductList([...newProductList]);  
        setShowProductLoader(false);

    }, [debouncedSearchTerm, productList, selectedProducts, dispatch, allSelected])


    // if (!allSelected) {
    //     newProductList.each((product) => {
    //         if (!!selectedProducts[product.id]) { newSelectedProducts[product.id] = { product, selected : true} }
    //     })
    // }

    

    const  toggleSelectAll = React.useCallback((value) => {
        setAllselected(value)
        if (value) {
            const allSelected = productList.reduce((accu, product) => { accu[product.id] = { product, isSelected : true }; return accu}, {})
            setSelectedProducts({...allSelected})
        } else {
            setSelectedProducts({});
        }
    }, [productList]);

    useEffect(() => {
        // all products default to selected
        toggleSelectAll(false)
    }, [toggleSelectAll])





    function setSelected(product, value) {
        if (value) {
            setSelectedProducts({...selectedProducts, [product.id] : { product, isSelected : value}});
        } else {
            const newProducts = {...selectedProducts};
            delete newProducts[product.id];
            setSelectedProducts(newProducts);
        }
    }



    return (<div style={{ width: '300px', display: 'flex', flex: 0, flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
        <TextField style={{margin: '20px 10px', flex: 0, }} id="outlined-basic" label="" variant="outlined" size="small" onChange={searchTextChanged} placeholder="Search Products..." value={searchText} />
        { showProductLoader && <LinearProgress />}
        <FormControlLabel
                            control={<Checkbox checked={allSelected} onChange={(e) => { toggleSelectAll(!allSelected) }} />}
                            label={<i>Select All</i>}
                            style={{ borderBottom: '1px solid #ccc', width: '100%', paddingLeft: '12px' }}
                        />

        <div style={{ heiught: '100%', overflowY: 'scroll', flex: 1, overflowX: 'hidden' }} >
            {filteredProductList.length ? filteredProductList.map((r) => {
                return (
                        <FormControlLabel
                            key={r.id}
                            control={<Checkbox checked={selectedProducts[r.id]?.isSelected || false} onChange={(e) => { setSelected(r, e.target.checked) }} />}
                            label={r.name}
                            style={{ borderBottom: '1px solid #ccc', width: '100%', paddingLeft: '12px' }}
                        />
                )
            }) :  (<div style={{ width : '100%', padding: '20px', textAlign : 'center', color : '#ccc'}}><i>No Results</i></div>)}
        </div>
    </div>)
}
